var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-banner-wrapper"},[_c('WphkBanner',{class:[
      'main-banner',
      { mul: _vm.bannerList.length > 0, one: _vm.bannerList.length === 1 } ],attrs:{"type":"swiper","bannerList":_vm.bannerList,"isMultBrow":false},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }